interface Configuration {
  jimdoEnvironment: 'devbox' | 'dev' | 'stable' | 'prod';
  jimdoDomain: string;
  language: string;
  version: string;
  username: string;
  email: string;
  avatar: string;
  dolphinCmsEndpoint: string;
  dashEndpoint: string; // TODO cleanup GRW-1410
  userLanguage: string;
  userId: string;
  createdAt: string;
  country: string;
}

const defaultConfig = {
  language: 'de',
  jimdoEnvironment: 'dev',
  jimdoDomain: 'jimdo.dev',
  version: 'dev',
  username: '',
  email: '',
  avatar: '',
  dolphinCmsEndpoint: 'https://cms.jimdo-stable-staging.com',
  dashEndpoint: 'https://dash.e.jimdo-stable-staging.com', // TODO cleanup GRW-1410
  userLanguage: 'de',
  createdAt: '2018-09-09T09:00:59.665Z',
  userId: '11111111-1111-1111-1111-111111111111',
  country: 'DE',
};

const config = (() => {
  try {
    return JSON.parse(window.__signup_flow_config__);
  } catch (e) {
    return defaultConfig;
  }
})();

export default function getConfig(): Configuration {
  return config;
}
